<template>
  <div class="compatible__grid">
    <SkeletonDiv v-if="Object.keys(compatibleProducts).length === 0" :width="306" :height="323" v-for="n in 4" :key="n"/>
    <div v-for="(products,type) in compatibleProducts" v-if="products.length > 0">
      <h4>{{ relatedTypes[type] }}</h4>
      <CompatibleProduct :products="products"/>
    </div>
  </div>
</template>

<script>
import GridAutoColumns from "@/components/partials/layout/GridAutoColumns";
import CompatibleProduct from "@/front/components/product/CompatibleProduct";
import {mapGetters} from "vuex";
import SkeletonDiv from "@/components/skeletons/SkeletonDiv";

export default {
  name: "AccessoiresCompatibles",
  components: {SkeletonDiv, CompatibleProduct, GridAutoColumns},
  data() {
    return {
      compatibleProducts: {},
    }
  },
  computed: {
    ...mapGetters(['relatedTypes']),
  },
  beforeMount() {
    // WP Rest Cache doesn't cache nonced requests by default use fetch() instead of $api here
    fetch(`/wp-json/g2r/v1/compatible/${g2rObj.postId}`)
      .then(response => response.json())
      .then(data => this.compatibleProducts = data)
  },
}
</script>

<style lang="scss">
.compatible__grid {
  display: grid;
  grid-template-columns:  repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 2rem;
  margin-bottom: 2rem;

  & > div {
    border: 1px solid var(--dark-blue);
    text-align: center;
    background-color: white;

    h4 {
      margin: 1rem auto;
      //background: linear-gradient(90deg, #ff5b5b, orange);
      background: linear-gradient(to left, var(--dark-blue), var(--green));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}

//@media screen and (min-width: 1024px) {
//  .compatible__grid {
//    grid-template-columns:  repeat(4, minmax(200px, 1fr)) !important;
//  }
//}
</style>
